'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isBeforeDay = {};

exports.__exports = isBeforeDay;
